<template>
  <li class="editable-list-row-ui">
    <slot />
  </li>
</template>
